import React, { useMemo, useState } from 'react'
import { Stack } from '@mui/material'
import ScrollTable from 'components/global/CUK/ScrollTable'
import CONFIG_COLUMNS from './config-columns'
import { useParams } from 'react-router-dom'
import TableView, { useTable } from 'packages/ui/Table'
import { useNavigate } from 'router'
import useSort from '../use-sort'

const PAGE_SIZE = 20

const Table = ({ sites }) => {
  const [page, setPage] = useState(0)
  const { focusId } = useParams()
  const sort = useSort({})
  const navigate = useNavigate()
  const hideColumnsNames = useMemo(() => {
    return CONFIG_COLUMNS.filter(({ name }) => {
      return (
        sites.reduce((acc, site) => site.equipment[`nb_${name}`] + acc, 0) === 0
      )
    }).map(({ name }) => name)
  }, [sites])
  const columns = useMemo(() => {
    const hideTypes = ['accesspoints', 'switches', 'esls', 'tvs', 'chromecasts', 'firewalls', 'inverters', 'cctv_cameras', 'cctv_servers']
    return CONFIG_COLUMNS.filter(
      ({ name }) =>
        (!focusId && !hideColumnsNames.includes(name)) ||
        (focusId && !hideTypes.includes(name)),
    )
  }, [focusId, hideColumnsNames])

  const selection = useMemo(() => {
    return sort.sort(sites).slice(0, (page + 1) * PAGE_SIZE)
  }, [sites, page, sort.orderBy, sort.orderDirection])

  const apiTable = useTable({
    rowKey: 'sf_id',
    items: selection,
    columns,
    onRowClick: (contact) => {
      navigate({ pathname: `${contact.sf_id}` })
    },
  })

  return (
    <Stack
      sx={{
        overflow: 'hidden',
        overflowY: 'auto',
        flex: '1 1 auto',
        scrollbarWidth: 'none',
        height: '100%',
        '&::-webkit-scrollbar ': {
          display: 'none',
        },
      }}
    >
      <ScrollTable
        fetchNextPage={() =>  setPage(prev => prev + 1)}
        shouldFetchNextPage={(page + 1) * PAGE_SIZE < sites.length}
        collapse={focusId}
      >
        <TableView
          apiTable={apiTable}
          sort={{
            by: sort.orderBy,
            direction: sort.orderDirection,
            onChange: (name) => {
              const column = columns.find((column) => column.name === name)
              sort.orderByChange(column.sortBy || column.name)
            },
          }}
        />
      </ScrollTable>
    </Stack>
  )
}

export default Table
